import { db } from '@config/firebaseConfig';
import { doc, setDoc, collection, deleteDoc, serverTimestamp } from "firebase/firestore";

/**
 * Generates a new document reference to pre-obtain a unique Firebase ID.
 * Useful for mapping IDs before external operations like image uploads.
 */
export const getNewProductRef = () => {
    return doc(collection(db, "products"));
};

/**
 * Persists product data into Firestore using a predefined reference.
 * Includes automatic timestamping and initialization of the comments array.
 */
export const saveProductWithRef = async (productRef, productData) => {
    try {
        await setDoc(productRef, {
            ...productData,
            id: productRef.id,
            created_at: serverTimestamp(),
            comments: []
        });
        return true;
    } catch (e) {
        // Error handling is delegated to the caller for custom UI feedback
        throw e;
    }
};

/**
 * Removes a specific product document from Firestore using its unique ID.
 */
export const deleteProduct = async (id) => {
    try {
        const productRef = doc(db, "products", id);
        await deleteDoc(productRef);
        return true;
    } catch (e) {
        throw e;
    }
};